module.exports = __webpack_public_path__ + "img/icon_search.665cd447.png";